import React from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { useNavigation } from '@react-navigation/native';
import { AntDesign, FontAwesome } from '@expo/vector-icons';
import { LoteScreen } from '../screens/LoteScreen';
import { OeeScreen } from '../screens/OeeScreen';
import { GraficoScreen } from '../screens/GraficoScreen';
import { ProducaoScreen } from '../screens/ProducaoScreen';
import { AlarmeScreen } from '../screens/AlarmeScreen';
import { useRoute } from '@react-navigation/native';

const DeviceScreen = () => {
  const route = useRoute();
  const { deviceName, numAtivos } = route.params;
  const Tab = createBottomTabNavigator();
  const tabBarBadge = numAtivos > 0 ? numAtivos : undefined;
  const navigation = useNavigation();

  React.useLayoutEffect(() => {
    if (deviceName) {
      navigation.setOptions({ title: deviceName });
    }
  }, [navigation, deviceName]);

  return (
    <Tab.Navigator
      screenOptions={{
        tabBarActiveTintColor: '#0081CF',
        tabBarInactiveTintColor: '#040404',
        headerShown: false,
        lazy: false,
        lazyPreloadDistance: 1,
        tabBarStyle: {
          backgroundColor: '#F3F3F1',
        },
      }}
    >
      <Tab.Screen
        name="PRD"
        component={ProducaoScreen}
        initialParams={{ deviceName: deviceName }}
        options={{
          tabBarIcon: ({ size, color }) => (
            <FontAwesome name="thermometer" size={size} color={color} />
          ),
        }}
      />
      <Tab.Screen
        name="LTE"
        component={LoteScreen}
        initialParams={{ deviceName: deviceName }}
        options={{
          tabBarIcon: ({ size, color }) => (
            <AntDesign name="profile" size={size} color={color} />
          ),
        }}
      />
      <Tab.Screen
        name="OEE"
        component={OeeScreen}
        initialParams={{ deviceName: deviceName }}
        options={{
          tabBarIcon: ({ size, color }) => (
            <AntDesign name="dashboard" size={size} color={color} />
          ),
        }}
      />
      <Tab.Screen
        name="GRF"
        component={GraficoScreen}
        initialParams={{ deviceName: deviceName }}
        options={{
          tabBarIcon: ({ size, color }) => (
            <AntDesign name="barschart" size={size} color={color} />
          ),
        }}
      />
      <Tab.Screen
        name="ALM"
        component={AlarmeScreen}
        initialParams={{ deviceName: deviceName }}
        options={{
          tabBarBadge: tabBarBadge,
          tabBarIcon: ({ size, color }) => (
            <AntDesign name="bells" size={size} color={color} />
          ),
        }}
      />
    </Tab.Navigator>
  );
};

export default DeviceScreen;
